import * as PopoverPrimitive from '@radix-ui/react-popover';
import { styled } from '@flex-design-system/stitches-react';
import { ScrollArea } from '../../scroll-area/ScrollArea.mjs';
import { contentStyle, contentInnerStyle } from '../shared/styles.mjs';

const StyledContent = styled(PopoverPrimitive.Content, {
  ...contentStyle,
  variants: {
    /**
     * @description - props로 animation 사용 여부를 결정 할 수 있도록 합니다.
     */
    prefersReducedMotion: {
      noPreference: {
        // Nothing
      },
      reduce: {
        "&&": {
          animationDuration: 0,
          animationName: "none"
        }
      }
    }
  }
});
const StyledContentInner = styled("div", {
  ...contentInnerStyle,
  // 좌표계 설정을 위한 값
  // https://flex-cv82520.slack.com/archives/CS05YNN9H/p1683554369675789
  willChange: "transform"
});
const StyledViewport = styled(ScrollArea.Viewport_Legacy);

export { StyledContent, StyledContentInner, StyledViewport };
//# sourceMappingURL=styled.mjs.map
